<div class="k-overlay dark-background"></div>

<kendo-dialog
  [width]="720"
  [maxHeight]="720"
  class="gamma-orders-dialog"
  (close)="close()"
>
  <div class="gamma-orders-shell">
    <div class="gamma-orders-close">
      <button
        type="button"
        (click)="close()"
        class="btn btn3"
        rounded="full"
        style="
          background-color: #e90000;
          color: #ffffff;
          width: 35px !important;
          height: 35px !important;
        "
      >
        <i
          class="bx bx-x bx-sm posRelBox2"
          style="
            color: #ffffff;
            bottom: 10px;
            position: relative !important;
            left: -80% !important;
            top: -1px !important;
          "
        ></i>
      </button>
    </div>

    <div class="gamma-orders-modal">
      <div class="gamma-orders-header">
        <h1 class="gamma-orders-title">Cerca ordine..</h1>

        <div class="gamma-orders-search">
          <label class="gamma-orders-search__input" for="gamma-order-search">
            <i class="bx bx-search"></i>
            <input
              id="gamma-order-search"
              type="text"
              placeholder="N° conto lavoro livith 0000.."
              [value]="orderNumber"
            />
          </label>

          <button type="button" class="gamma-orders-search__button">
            <i class="bx bx-search"></i>
            <span>CERCA</span>
          </button>
        </div>
      </div>

      <div class="gamma-orders-divider"></div>

      <div class="gamma-orders-grid-wrapper">
        <kendo-grid
          class="gamma-orders-grid"
          [kendoGridBinding]="
            gammaOrders.length
              ? gammaOrders
              : ordersFromGammaResponse.order_number
                ? [ordersFromGammaResponse]
                : []
          "
          [rowHeight]="rowHeight"
          [height]="190"
          [pageSize]="pageSize"
          scrollable="virtual"
          [navigable]="false"
          [sortable]="false"
          [reorderable]="false"
          [resizable]="false"
        >
          <kendo-grid-column
            [width]="90"
            title="Seleziona"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
          >
            <ng-template kendoGridCellTemplate>
              <span class="gamma-orders-select-badge" aria-hidden="true">
                <i class="bx bx-check"></i>
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="135"
            field="order_number"
            title="N&#176; ordine"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="gamma-orders-order-number">
                {{ dataItem.orderNumber || dataItem.order_number }}
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="300"
            title="Stato / Pagina"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="gamma-orders-status">
                {{
                  dataItem.statusPage ||
                    dataItem.status_page ||
                    dataItem.status ||
                    "Da processare / Ordini in lavorazione"
                }}
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-command-column
            title="Processa"
            [width]="110"
            [headerStyle]="{ 'justify-content': 'center' }"
            [style]="{ 'text-align': 'center' }"
          >
            <ng-template kendoGridCellTemplate>
              <button
                type="button"
                class="manufacturer-icon-button manufacturer-icon-button--process"
                title="Processa ordine"
              >
                <i class="bx bx-run"></i>
              </button>
            </ng-template>
          </kendo-grid-command-column>

          <ng-template kendoGridNoRecordsTemplate>
            <div class="manufacturer-empty-state gamma-orders-empty-state">
              <p>Nessun ordine disponibile.</p>
            </div>
          </ng-template>
        </kendo-grid>
      </div>
    </div>
  </div>
</kendo-dialog>
